<template>
    <section id="terms" class="page-text">
        <app-page-title
            :title="$i18n.t('terms.title')"
            bg-filter="363deg"
        ></app-page-title>
        <rz-content-wrapper>
            <div class="align-left">
                <p>
                    Este contrato describe los términos y condiciones generales
                    (los "Términos y Condiciones Generales" o los “Términos”)
                    aplicables al uso de los Servicios ofrecidos por ANTIRION
                    SpA ("los Servicios") a través de internet mediante sitios
                    web ("Sitios ANTIRION") o aplicaciones nominadas de ANTIRION
                    ("Aplicaciones ANTIRION") o por acceso a Servicios de
                    integración (“API’s ANTIRION"). Cualquier persona que desee
                    acceder y/o usar los Servicios podrá hacerlo aceptando estos
                    Términos y Condiciones Generales, junto con todas las demás
                    políticas y principios que rigen los Servicios ANTIRION y
                    que son incorporados al presente por referencia.
                </p>

                <p>
                    El acceso y uso de estos Servicios y el uso de toda la
                    información contenida en él se rige por los Términos y
                    Condiciones Generales descritos a continuación, así como por
                    la legislación que se aplique en la República de Chile. En
                    consecuencia, todas las visitas y todos los contratos y
                    transacciones que se realicen en este sitio, como asimismo
                    sus efectos jurídicos, quedarán regidos por estas reglas y
                    sometidas a esa legislación.
                </p>

                <p>
                    CUALQUIER PERSONA -NATURAL O JURÍDICA- QUE NO ACEPTE ESTOS
                    TÉRMINOS Y CONDICIONES GENERALES, LOS CUALES TIENEN UN
                    CARÁCTER OBLIGATORIO Y VINCULANTE, DEBERÁ ABSTENERSE DE
                    UTILIZAR EL SITIO Y/O LOS SERVICIOS OFRECIDOS EN ÉL.
                </p>

                <p>
                    El cliente debe leer, entender y, si está dispuesto, aceptar
                    todas las condiciones establecidas en los Términos y
                    Condiciones Generales, así como en los demás documentos
                    incorporados a los mismos por referencia, previo a su
                    inscripción o registro como cliente de ANTIRION. De lo
                    contrario debe obtenerse de continuar.
                </p>

                <h3>01- Antecedentes.</h3>
                <p>
                    ANTIRION es una sociedad cuyo giro es la prestación de
                    Servicios computacionales orientados al ámbito de la
                    pequeña, mediana y gran empresa, la que tiene por objeto,
                    fundamentalmente, ayudar a mejorar la Gestión de Riesgos
                    Operacionales en Seguridad, Salud, Medio Ambiente,
                    Comunidad, Calidad y Activos de las empresas u
                    organizaciones que atienda, utilizando tecnologías de
                    internet como el principal canal de distribución de estos
                    Servicios, y proporcionándoles a estos efectos la
                    capacitación necesaria para el uso de los mismos.
                </p>

                <h3>02- Capacidad.</h3>
                <p>
                    La contratación de los Servicios solo está disponible para
                    personas que tengan capacidad legal para contratar y/o que
                    tengan capacidad suficiente para representar a la persona,
                    natural o jurídica, en nombre de quien contratan. En el caso
                    que se inscriba una empresa como cliente, quien lo hace en
                    su representación debe tener capacidad para contratar a
                    nombre de tal entidad y de obligarla en los términos de este
                    acuerdo, declarando desde ya que tiene capacidad suficiente
                    para ello. No podrán contratar los Servicios las personas
                    que no tengan la capacidad a la que se hace referencia en
                    este párrafo, los menores de edad o los usuarios de ANTIRION
                    que hayan sido suspendidos temporalmente o inhabilitados
                    definitivamente.
                </p>

                <h3>03- Inscripción.</h3>
                <p>
                    Es imprescindible completar el formulario de inscripción
                    como cliente, en todos sus campos obligatorios, con datos
                    válidos para poder utilizar los Servicios que brinda
                    ANTIRION. El cliente deberá completarlo con información
                    exacta, precisa y verdadera.
                </p>
                <p>
                    El cliente asume el compromiso de actualizar los datos
                    conforme resulte necesario. ANTIRION podrá utilizar diversos
                    medios para identificar a sus usuarios y NO se
                    responsabiliza por la certeza de los datos que hayan sido
                    provistos por sus futuros clientes, clientes actuales y/o
                    sus usuarios actuales. Los clientes y sus usuarios
                    designados, garantizan y responden, en cualquier caso, de la
                    veracidad, exactitud, vigencia y autenticidad de los datos
                    ingresados.
                </p>
                <p>
                    El cliente, para acceder a los Servicios proporcionados por
                    ANTIRION, contará con una clave de ingreso asignada por esta
                    última. Una vez recibida la clave, podrá cambiarla a su
                    propia conveniencia de acuerdo con las instrucciones que al
                    efecto le indique ANTIRION.
                </p>
                <p>
                    La clave de ingreso es personal, única e intransferible para
                    cada cliente. El cliente declara que toda operación
                    efectuada, o cualquier uso del Servicio realizado por alguna
                    persona usando su clave de ingreso, debe entenderse
                    realizada por él mismo. En tal caso, y cumplido este
                    requisito, ANTIRION podrá considerar que tal operación o uso
                    ha sido realizada válida, legítima y auténticamente por el
                    cliente, sin necesidad de tomar otro resguardo. Lo anterior
                    incluye todas las comunicaciones que envíe el cliente hacia
                    ANTIRION, mientras permanece conectado a alguna de las
                    funcionalidades de los Servicios.
                </p>
                <p>
                    Será requisito necesario para la adquisición de cualquier
                    Servicio y/o productos ofrecidos en este sitio, además del
                    registro por parte del cliente, la aceptación de estos
                    Términos y Condiciones Generales. Se entenderán conocidos y
                    aceptados estos Términos y Condiciones Generales por el
                    hecho de su aceptación expresa mediante su manifestación de
                    voluntad a través de la selección de conformidad en la
                    pantalla o interfaz de consulta respectiva.
                </p>
                <p>
                    Cualquier cambio en el Servicio solicitado por el usuario
                    administrador designado por el cliente (“Administrador
                    ANTIRION”) se entenderá incorporado a los Servicios
                    originalmente contratados, modificándose, en consecuencia,
                    el precio de los Servicios. Otros cambios a los Servicios
                    originalmente contratados deberán ser notificados vía correo
                    electrónico a
                    <a href="mailto:contrato@antirion.cl"
                        >contrato@antirion.cl</a
                    >
                    . ANTIRION dispondrá de hasta treinta (30) días corridos
                    para evaluar y notificar al Cliente acerca de su solicitud.
                    Tras la notificación, los cambios se verán reflejados en el
                    siguiente ciclo de facturación. Dichos cambios no cubrirán
                    en ningún caso, ni total ni parcialmente: morosidades,
                    cargos adicionales, exceso sobre planes contratados u otros
                    similares de ciclos de facturación pasados.
                </p>
                <p>
                    ANTIRION podrá incluir en su Plataforma el envío de un
                    mensaje por parte del usuario administrador designado por el
                    cliente, como un mecanismo de solicitud válido para la
                    contratación de alguna combinación de Servicios que no está
                    disponible en el sitio, pero que ANTIRION eventualmente
                    pueda habilitar. A su exclusiva discreción, ANTIRION podrá
                    requerir una inscripción adicional a sus clientes como
                    requisito para acceder a condiciones especiales de
                    contratación.
                </p>
                <p>
                    ANTIRION se reserva el derecho de solicitar algún
                    comprobante y/o dato adicional a efectos de corroborar los
                    datos del cliente así como de suspender temporal o
                    definitivamente a aquellos clientes y/o a sus usuarios,
                    cuyos datos no hayan podido ser confirmados. En estos casos
                    de inhabilitación, se bloquearán todos los informes o datos
                    registrados, así como las consultas realizadas, sin que ello
                    genere algún derecho a resarcimiento. Lo mismo ocurrirá en
                    caso de no pago de los Servicios contratados.
                </p>
                <p>
                    Tanto el cliente como sus usuarios designados, accederán a
                    sus respectivas cuentas personales ("Cuenta") mediante un
                    identificador del cliente y/o usuario y de su clave de
                    ingreso personal elegida ("Clave de Seguridad"). El cliente
                    y sus usuarios se obligan a mantener la confidencialidad de
                    sus respectivas Claves de Seguridad.
                </p>
                <p>
                    El cliente y sus usuarios designados se comprometen a
                    notificar a ANTIRION en forma inmediata, y por medios
                    idóneos y fehacientes, cualquier uso no autorizado de su
                    Cuenta, así como el ingreso por terceros no autorizados a la
                    misma.
                </p>

                <p>
                    <strong
                        >La venta, cesión o transferencia de una Cuenta, bajo
                        cualquier título, se encuentra expresamente prohibida.
                    </strong>
                </p>
                <p>
                    ANTIRION se reserva el derecho de rechazar cualquier
                    solicitud de inscripción, sin que esté obligada a comunicar
                    o exponer las razones de su decisión y sin que ello genere
                    algún derecho a indemnización o resarcimiento.
                </p>

                <h3>04- Modificaciones del Acuerdo.</h3>
                <p>
                    ANTIRION podrá modificar los Términos y Condiciones
                    Generales en cualquier momento haciendo público en el Sitio
                    los términos modificados. Todos los términos modificados
                    estarán dispuestos en las Cuentas de cada uno de los
                    clientes y entrarán en vigor en el momento de su aceptación
                    electrónica en el sitio. Sí, habiéndose modificado los
                    Términos y Condiciones Generales, éstos no son aceptados
                    dentro del plazo de 90 días desde su publicación, ANTIRION
                    tendrá el derecho de inhabilitar al cliente, sin que ello
                    genere derecho a resarcimiento alguno. En este último caso,
                    los Servicios no podrán ser utilizados más allá del plazo
                    señalado, hasta que no se conforme la aceptación de los
                    nuevos Términos y Condiciones Generales en la Plataforma.
                </p>
                <p>
                    Si el cliente quisiera no aceptar los nuevos Términos y
                    Condiciones Generales, deberá comunicarlo por e-mail al
                    correo
                    <a href="mailto:contrato@antirion.cl"
                        >contrato@antirion.cl</a
                    >, en cuyo caso ANTIRION podrá disolver el vínculo
                    contractual e inhabilitar al cliente para continuar usando
                    los Servicios.
                </p>

                <h3>05- Obligaciones.</h3>
                <p>
                    Sin perjuicio de las demás obligaciones que contemplan estos
                    Términos y Condiciones Generales, tanto ANTIRION como los
                    clientes estarán especialmente obligados a:
                </p>

                <h4>ANTIRION</h4>
                <ul>
                    <li>
                        Mantener los sistemas funcionando con un nivel de uptime
                        del 98% anual. No obstante lo anterior, el Servicio
                        podrá ser interrumpido por ANTIRION cuando sea necesario
                        por razones técnicas o de mantenimiento. En estos casos
                        los trabajos se realizarán preferentemente en días no
                        hábiles y se avisará mediante el sitio de ANTIRION con
                        un plazo mínimo de 1 día de anticipación. Se exceptúan
                        de este aviso, los trabajos que hayan sido motivados por
                        circunstancias de caso fortuito o fuerza mayor;
                    </li>
                    <li>
                        Mantener los sistemas actualizados disponiendo de un
                        sistema de Soporte vía correo electrónico para atender y
                        resolver las dudas o problemas que se susciten por parte
                        del cliente. Este Servicio será prestado de lunes a
                        viernes
                    </li>
                    <li>
                        de 9:00 a 18:00 horas en días hábiles, horario de
                        Santiago de Chile, reservándose ANTIRION el derecho de
                        extender o reducir el horario de dichos Servicios según
                        lo considere necesario;
                    </li>
                    <li>
                        Entregar el espacio de almacenamiento suficiente para
                        todas las operaciones del cliente relacionadas
                        directamente con los Servicios contratados y vigentes de
                        ANTIRION y bajo los niveles de seguridad adecuados;
                    </li>
                    <li>
                        Mantener la información relativa al cliente mientras
                        mantenga el Servicio contratado y,
                    </li>
                    <li>
                        Prestar al cliente aquellos Servicios que este último
                        contrate.
                    </li>
                </ul>

                <h4>El cliente</h4>
                <ul>
                    <li>
                        Registrarse con una cuenta de usuario proporcionando
                        toda la información necesaria para acceder a la
                        Plataforma Web y/o utilizar los Servicios de ANTIRION;
                    </li>
                    <li>
                        Proporcionar información verdadera, exacta, actual y
                        completa según lo solicite el proceso de registro de la
                        Plataforma Web;
                    </li>
                    <li>
                        Mantener y actualizar oportunamente la información
                        proporcionada durante el registro para que sea
                        verdadera, exacta, actual y completa. Si proporciona
                        información falsa, inexacta, desactualizada o
                        incompleta, o si ANTIRION tiene motivos razonables para
                        sospechar que dicha información es falsa, inexacta,
                        desactualizada o incompleta, podrá cancelar su cuenta de
                        usuario y rechazar el uso actual o futuro de uno o de
                        todos los Servicios.
                    </li>
                    <li>
                        Actuar en conformidad con los Servicios prestados por
                        ANTIRION;
                    </li>
                    <li>
                        Contar con todos los medios técnicos para acceder a la
                        red internet y usar los Servicios, tales como equipos
                        (hardware) y programas (software) adecuados. La falta de
                        estos medios o el hecho que éstos no tengan las
                        aptitudes técnicas necesarias no será, en caso alguno,
                        de responsabilidad de ANTIRION. Adicionalmente, el
                        cliente debe mantener configurados los equipos y
                        programas de manera que permitan el uso adecuado de los
                        Servicios;
                    </li>
                    <li>
                        Pagar el precio convenido, en la forma y plazo
                        correspondiente al contrato o Términos y Condiciones
                        vigente con ANTIRION;
                    </li>
                    <li>
                        Mantener reserva acerca de la clave de ingreso asignada
                        a cada Usuario, y usarlas diligentemente, de manera que
                        ésta sea utilizada exclusivamente por los usuarios
                        designados;
                    </li>
                    <li>
                        El cliente se obliga además a comunicar a ANTIRION en el
                        más breve plazo, el caso de pérdida de la clave de
                        ingreso, de manera que ANTIRION pueda adoptar las
                        medidas pertinentes para evitar un uso inadecuado de
                        ella por terceros. A falta de aviso, el cliente será
                        responsable de todos los perjuicios y gastos causados en
                        la utilización de los Módulos por terceros, mediante el
                        uso de su clave de ingreso;
                    </li>
                    <li>
                        Usar los Módulos que comprende el Servicio contratado en
                        forma tal que no pueda dañar, inutilizar, sobrecargar,
                        afectar o deteriorar los equipos y programas de
                        ANTIRION, de otros clientes o de terceros, así como los
                        archivos, documentos y programas contenidos en equipos o
                        sistemas de ANTIRION o de terceros;
                    </li>
                    <li>
                        No utilizar el Servicio, para fines que atenten a la
                        moral y a las buenas costumbres y, en general, para
                        fines que, a juicio exclusivo de ANTIRION, atenten
                        contra la ley o a las políticas comerciales de ANTIRION.
                    </li>
                </ul>

                <h3>06- Listado de Servicios y Precios.</h3>
                <p>
                    El cliente podrá tener acceso a los Servicios de ANTIRION,
                    que contrate directamente a través de la página de ANTIRION,
                    o bien que haya contratado anteriormente a través de
                    cualquier otro medio. ANTIRION se reserva el derecho de
                    complementar los Servicios con textos descriptivos,
                    gráficos, aplicaciones y otros contenidos y condiciones
                    pertinentes para su utilización, siempre que no violen
                    ninguna disposición legal, ni estos Términos y Condiciones
                    Generales ni demás políticas de ANTIRION.
                </p>

                <p>
                    Se establece que los precios de los Servicios ofrecidos son
                    aquellos que, a la fecha de contratación, se indican en el
                    Sitio ANTIRION, para cada uno o más de ellos, y cuya
                    equivalencia en pesos, ya que están expresados en unidades
                    de fomento (UF), corresponderá a la del día que se consigne
                    en la factura respectiva. En el Sitio ANTIRION también
                    estarán publicadas las funcionalidades propias de los
                    Servicios ofrecidos, así como las variables de precio que
                    determinan cada plan de suscripción.
                </p>

                <p>
                    Para el caso de que el cliente haya contratado su plan de
                    suscripción con un descuento sobre el precio publicado a la
                    fecha de contratación, el valor de la suscripción respectiva
                    será actualizado sólo conforme a lo pactado a la fecha de
                    contratación, sin necesidad de notificación. Así, los nuevos
                    precios entrarán en vigor según lo originalmente contratado.
                    En todo caso, el descuento se mantendrá vigente sólo en la
                    medida en que se mantengan los Servicios originalmente
                    contratados. Cualquier modificación efectuada por el cliente
                    respecto de dichos Servicios, hará perder el derecho al
                    descuento.
                </p>

                <p>
                    ANTIRION se reserva el derecho de hacer modificaciones a los
                    precios, variables de precio y funcionalidades de los
                    distintos planes de suscripción. En tal caso se le
                    notificará al cliente el nuevo valor a ser cobrado por
                    correo electrónico o en el sitio privado de ANTIRION y/o
                    mediante carta certificada. Si, habiéndose modificado los
                    precios, variables de precio y/o funcionalidades de los
                    distintos planes de suscripción, éstos no son aceptados
                    dentro del plazo de 30 días desde su publicación, ANTIRION
                    tendrá el derecho de inhabilitar al cliente, sin que ello
                    genere derecho a resarcimiento alguno. En caso de que se
                    continúe otorgando el Servicio por parte de ANTIRION, se
                    entenderá que el uso de los Servicios más allá de 30 días
                    posteriores al plazo de la publicación de los nuevos
                    precios, variables de precio y/o funcionalidades de los
                    distintos planes de suscripción, supone la aceptación tácita
                    de estos últimos.
                </p>

                <p>
                    ANTIRION podrá retractarse de una venta efectuada a uno o
                    más clientes, cuando no sea posible verificar la verdadera
                    identidad o demás información del usuario.
                </p>

                <p>
                    Tal como lo establece la normativa vigente, ANTIRION emitirá
                    una factura por los Servicios contratados, factura que será
                    enviada al correo electrónico registrado por el cliente,
                    siendo de responsabilidad de este último mantenerlo
                    debidamente actualizado.
                </p>

                <p>
                    Los pagos que hará el cliente a ANTIRION por el Servicio
                    contratado, deberán efectuarse en forma anticipada dentro de
                    los diez primeros días de cada mes mediante el sistema de
                    pago digital con cargo a la Tarjeta de Crédito, Tarjeta de
                    Débito o cualquier otra forma que ANTIRION comunique como
                    opción. En caso que un cliente no utilice los medios de pago
                    mencionados anteriormente, ANTIRION estará facultado para no
                    ingresar dicho pago, haciendo devolución del mismo según
                    datos proporcionados por el cliente, quien, sin perjuicio de
                    lo anterior, deberá regularizar el pago referido por alguno
                    de los medios vigentes.
                </p>

                <p>
                    En caso de retardo en el pago del precio por un período
                    superior a cinco días calendario desde la fecha de
                    vencimiento de la respectiva cuota, ANTIRION quedará
                    facultada para suspender el Servicio al cliente. En caso de
                    retardo en el pago, el cliente no tendrá derecho a solicitar
                    nota de crédito por gastos de cobranza, aun cuando hubiese
                    efectuado un pago por otro medio distinto de los señalados
                    dentro de los diez primeros días de cada mes.
                </p>

                <p>
                    En este mismo sentido, el cliente autoriza a ANTIRION, para
                    que en caso de incumplimiento de las obligaciones contraídas
                    conforme estos Términos y Condiciones Generales, sus datos
                    sean ingresados, procesados, tratados y comunicados a
                    terceros sin restricciones, e ingresados en un registro o
                    banco de datos público. La reposición del Servicio será
                    efectuada por ANTIRION dentro del plazo de un día hábil,
                    contado desde que se realice el pago de lo adeudado y dicho
                    pago se encuentre debidamente acreditado. En el evento que
                    la reposición tenga un costo, éste deberá ser igualmente
                    pagado y acreditado por parte del cliente, previo a su
                    reposición.
                </p>

                <p>
                    ANTIRION se reserva el derecho de adoptar las medidas
                    judiciales y extrajudiciales que estime pertinentes para
                    obtener el pago de las cantidades adeudadas.
                </p>

                <p>
                    Excepcionalmente ANTIRION podrá prestar Servicios
                    especialmente acordados con sus clientes, como por ejemplo
                    migración de datos, copia de información, creación de
                    perfiles especiales, y otros que puedan desarrollarse en el
                    futuro, fijándose para cada Servicio el valor que estime
                    pertinente. Lo anterior, no implica que ANTIRION se
                    encuentre obligado a prestar esos Servicios de manera
                    permanente o a otros clientes.
                </p>

                <p>
                    Las promociones y descuentos que ANTIRION publique con
                    motivo de campañas comerciales, sólo serán válidas para
                    clientes nuevos y sus nuevas contrataciones.
                </p>

                <p>
                    Por su parte, el cliente podrá poner término a los Servicios
                    contratados, debiendo comunicar dicha solicitud a ANTIRION
                    mediante correo electrónico a
                    <a href="mailto:contrato@antirion.cl"
                        >contrato@antirion.cl</a
                    >, con a lo menos 30 días de anticipación a la fecha deseada
                    para el término.
                </p>

                <h3>07- Limitación de garantía y responsabilidad.</h3>
                <p>
                    ANTIRION, a través de sus Servicios, brinda a sus usuarios
                    contenido propio mediante la publicación del mismo en sus
                    diferentes páginas web y aplicaciones móviles. Dicho
                    contenido, de acceso voluntario y gratuito, puede ser usado
                    con carácter informativo y/o educativo por los usuarios de
                    los Servicios Antirion. Sin embargo, cabe señalar que
                    ANTIRION no se responsabiliza por errores u omisiones que
                    pueda contener dicho material. ANTIRION no se hace
                    responsable por las interpretaciones que los usuarios le den
                    a sus contenidos, ni del uso indebido de los mismos.
                    Asimismo, no se hará responsable por los daños o perjuicios
                    causados de forma directa o indirecta por quienes toman
                    decisiones o medidas en base a consultas realizadas al
                    contenido de los Servicios Antirion.
                </p>
                <p>
                    ANTIRION no se responsabilizará por los daños o perjuicios,
                    directos, indirectos, o de otra forma, que acarree la
                    suspensión o terminación de su contenido, servicios o
                    información que suministra a través de su sitio web o
                    aplicaciones móviles.
                </p>
                <p>
                    ANTIRION es libre de efectuar cambios, modificaciones y
                    actualizaciones en su contenido, sin previo aviso y sin
                    necesitar el consentimiento o conocimiento de sus usuarios
                    acerca de esto. Por tanto, no es responsable de los
                    perjuicios que estos cambios, modificaciones y/o
                    actualizaciones pudieran ocasionar a sus usuarios. ANTIRION
                    no tendrá responsabilidad alguna por los daños y perjuicios
                    de cualquier naturaleza, sean directos o indirectos,
                    previstos o imprevistos, que puedan deberse a la creación,
                    transmisión, difusión, recepción, obtención y puesta a
                    disposición de los contenidos a los que el cliente puede
                    acceder a través de los Servicios brindados por ANTIRION, y
                    en particular por los daños o perjuicios que puedan provenir
                    de:
                </p>
                <ol class="ol-latin">
                    <li>
                        La presencia de virus u otros elementos que puedan
                        producir daño, alteraciones o inconvenientes en los
                        equipos y programas del cliente, o en los archivos o
                        documentos contenidos en éstos;
                    </li>

                    <li>
                        De cualquier menoscabo, daño u otro deterioro que sufra
                        la información que se suministre a través de ANTIRION
                        por la acción de piratas informáticos o cualquier
                        interrupción, suspensión o desperfecto de la propia red
                        de internet. Es así como ANTIRION no se responsabiliza
                        por:
                        <ul class="ul-inside">
                            <li>
                                Caídas del sistema ocasionadas por fuerza mayor,
                                caso fortuito, hechos de la naturaleza, actos
                                terroristas, incendio, delitos y por cualquier
                                otra causa no imputable a ANTIRION;
                            </li>
                            <li>
                                Problemas de conexión a internet, mal uso del
                                sistema por parte del cliente,
                            </li>
                            <li>
                                Errores en los datos ingresados por el cliente,
                                fallas en el computador del cliente, Virus,
                                Troyanos, Spyware o cualquier otro tipo de
                                Malware (software hostil con objetivo de
                                infiltrarse y/o dañar computadores o sistemas de
                                información entre otros), en el computador del
                                cliente;
                            </li>
                        </ul>
                    </li>
                </ol>
                <h3>08- Propiedad Intelectual</h3>
                <p>
                    Queda prohibida la reproducción total y/o parcial del
                    contenido publicado en los Servicios Antirion (textos,
                    imágenes, gráficos, sonidos, videos, etc.). En el caso de
                    que se desee reproducir parte de algún artículo en una
                    página web o en algún otro medio, se deberá obtener una
                    autorización escrita previa de ANTIRION.
                </p>
                <p>
                    Los Servicios, los Sitios ANTIRION (incluyendo pero no
                    limitado al portal “<a href="www.antirion.cl"
                        >www.antirion.cl</a
                    >”), las Aplicaciones ANTIRION y las API’s ANTIRION, su
                    diseño y los contenidos que lo conforman, son de propiedad
                    de ANTIRION, quien se reserva todos sus derechos. Los
                    usuarios pueden acceder al portal y usar sus contenidos de
                    acuerdo a estos Términos y Condiciones Generales.
                </p>
                <h3>09- Confidencialidad</h3>
                <p>
                    ANTIRION y el cliente se comprometen y se obligan a
                    preservar la más estricta confidencialidad respecto de
                    cualquier información del otro, o sobre sus actividades
                    comerciales o su negocio, que se hubiera obtenido en virtud
                    de estos Términos y Condiciones Generales y/o de los
                    Servicios contratados conformes estos últimos. Esta
                    obligación subsistirá aún después de concluido el contrato.
                    ANTIRION se obliga a resguardar la seguridad de los datos
                    del cliente y de los datos personales de los usuarios por él
                    designados, adoptando todos los medios y técnicas a su
                    alcance para evitar la pérdida, mal uso, alteración, acceso
                    no autorizado o robo de esta información. No obstante lo
                    anterior, el cliente debe ser consciente de que las medidas
                    de seguridad en internet no son inexpugnables.
                </p>
                <p>
                    Sin perjuicio de lo señalado en los párrafos anteriores,
                    ANTIRION podrá revelar los datos del cliente y/o los datos
                    personales de los usuarios por él designados, en caso de ser
                    requerido por mandato legal o por una orden judicial, o en
                    el caso que el cliente infringiere estos Términos y
                    Condiciones Generales o las condiciones particulares que
                    regulen el acceso y uso de los Servicios ofrecidos en dicho
                    portal; o en aquellos casos en que sea imprescindible para
                    defender los derechos de ANTIRION, de otros clientes o de
                    terceros.
                </p>
                <h3>10- Infracciones.</h3>
                <p>
                    Cualquier infracción a los presentes Términos y Condiciones
                    Generales podrá ser investigada por ANTIRION y el infractor
                    podrá ser sancionado con la suspensión o cancelación de los
                    Servicios e incluso de su inscripción como cliente de
                    ANTIRION, sin perjuicio de las acciones legales a que pueda
                    dar lugar por la configuración de delitos o contravenciones
                    o por los perjuicios civiles que pueda causar.
                </p>

                <h3>11- Violaciones del Sistema o Bases de Datos.</h3>
                <p>
                    No está permitida ninguna acción o uso de dispositivo,
                    software, u otro medio tendiente a interferir tanto en las
                    actividades y operatoria de ANTIRION, como en los Servicios
                    ofrecidos por ésta. Si ANTIRION detectara acciones que
                    interfieren con el Servicio que brinda a sus clientes,
                    ANTIRION queda facultado para implementar restricciones o
                    suspender el Servicio.
                </p>
                <p>
                    Cualquier intromisión, tentativa o actividad violatoria o
                    contraria a las leyes sobre derecho de propiedad intelectual
                    y/o a las prohibiciones estipuladas en estos Términos y
                    Condiciones Generales harán responsable a quien las ejecute,
                    de las acciones legales pertinentes, y de las sanciones
                    previstas por este acuerdo, así como lo hará responsable de
                    indemnizar los daños ocasionados.
                </p>

                <h3>12- Alcance de los Servicios de ANTIRION.</h3>

                <p>
                    Este acuerdo no crea ningún contrato de sociedad, de
                    mandato, de franquicia, o relación laboral entre ANTIRION y
                    el cliente y/o los usuarios designados por éste. El usuario
                    reconoce y acepta que ANTIRION no tiene control alguno sobre
                    la calidad, seguridad o legalidad de los datos ingresados en
                    su Plataforma, ni de la veracidad o exactitud de los mismos.
                    ANTIRION no garantiza la veracidad de los datos ingresados y
                    no será responsable, por ende, de la correspondencia de
                    resultados obtenidos en la utilización de los Servicios
                    contratados.
                </p>

                <h3>13- Comunicaciones</h3>
                <p>
                    Para el adecuado desarrollo y ejecución de los Términos y
                    Condiciones, el Cliente deberán designar a uno o varios
                    representantes autorizados para coordinar, cualquier materia
                    o aspecto que diga relación con el debido cumplimiento a la
                    Contratación. Las Partes acuerdan que la notificación o
                    comunicación oficial para fines de los Servicios,
                    ampliaciones, modificaciones, nuevos servicios, entre otros,
                    y sus tarifas respectivas podrán acordarse, con validez a la
                    Contratación, por los correos electrónicos señalados, a
                    solicitud del cliente y bajo aprobación de ANTIRION, sin
                    necesidad de la firma de anexos o documentos adicionales.
                </p>
                <p>
                    El Servicio puede incluir ciertas comunicaciones de
                    ANTIRION, tales como anuncios de Servicio, mensajes
                    administrativos y boletines informativos. Usted entiende que
                    estas comunicaciones se considerarán parte del uso de los
                    Servicios. Como parte de nuestra política para brindarle
                    privacidad total, también le proporcionamos la opción de
                    optar por no recibir información nuestra. Sin embargo, no
                    podrá optar por dejar de recibir anuncios de servicio y
                    mensajes administrativos.
                </p>
                <p>
                    Las Partes podrán modificar los nombres de aquellas personas
                    que deban recibir notificaciones en su representación y sus
                    respectivas direcciones, números de teléfono y correos
                    electrónicos, perfiles de usuarios, administradores, entre
                    otros, siempre que tal notificación sea debidamente
                    notificada o ajustada por medio de la Plataforma Web en los
                    campos correspondientes.
                </p>
                <h3>14- Gastos de Cobranza.</h3>
                <p>
                    Como es de conocimiento del cliente, la Ley No 19.496 sobre
                    protección de los derechos de los consumidores, establece la
                    obligación de informar el sistema de cálculo de los gastos
                    que genere la cobranza extrajudicial, incluidos los
                    honorarios que corresponda, y las modalidades y
                    procedimientos de dicha cobranza, fijando al mismo tiempo
                    los montos máximos que por tales conceptos pueden cobrarse.
                </p>
                <p>
                    ANTIRION, con el objeto de dar cumplimiento a dicha ley,
                    informa en la siguiente tabla los honorarios de cobranza
                    extrajudicial que se aplicarán, conforme a la siguiente
                    escala progresiva:
                </p>
                <table class="antirion-table">
                    <thead>
                        <tr>
                            <td colspan="2">
                                Monto Adeudado o Cuota Vencida
                            </td>
                            <td rowspan="2">
                                Porcentaje a Cobrar por Concepto de Gastos de
                                Cobranza Extrajudicial Apartir día 20 de
                                Morosidad
                            </td>
                        </tr>
                        <tr>
                            <td>Desde</td>
                            <td>Hasta</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>UF 0,001</td>
                            <td>UF 10</td>
                            <td>9%</td>
                        </tr>
                        <tr>
                            <td>Mayor a UF 10</td>
                            <td>UF 50</td>
                            <td>6%</td>
                        </tr>
                        <tr>
                            <td>Mayor a UF 50</td>
                            <td>o más</td>
                            <td>3%</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    Las modalidades y procedimientos antes señalados podrán
                    sufrir modificaciones anualmente en términos que no resulten
                    más gravosos ni onerosos para los clientes ni se discrimine
                    entre ellos, lo que se comunicará, en su caso, con una
                    anticipación mínima de dos periodos de pago, conforme lo
                    establece la ley.
                </p>
                <p>
                    Asimismo, le informamos que la cobranza extrajudicial de
                    estos créditos, la realizará directamente ANTIRION, la que
                    desarrollará las gestiones de cobranza por vía telefónica,
                    correo electrónico, postal y/o en terreno, en días y horas
                    hábiles; esto es, de lunes a viernes de 9:00 a 18:00 horas.
                </p>
                <p>
                    Evite eventuales cortes del suministro de los Servicios y
                    costos adicionales por concepto de reposición.
                </p>
                <h3>
                    15- Jurisdicción y Ley Aplicable.
                </h3>
                <p>
                    Estos Términos y Condiciones Generales estarán regidos en
                    todos sus puntos por las leyes vigentes en la República de
                    Chile.
                </p>
                <p>
                    Cualquier controversia derivada del presente acuerdo, su
                    existencia, validez, interpretación, alcance o cumplimiento,
                    será sometida a las leyes aplicables y a los Tribunales
                    Ordinarios competentes de la comuna de Viña del Mar y los
                    procedimientos se llevarán a cabo en idioma castellano.
                </p>
                <h3>
                    16- Domicilio.
                </h3>
                <p>
                    Se fija como domicilio de ANTIRION SpA el ubicado en Avenida
                    Uno Norte 468, Oficina 707, Viña del Mar, Chile.
                </p>
                <p>
                    Si tiene alguna duda sobre los Términos y Condiciones
                    Generales o demás políticas y principios que rigen ANTIRION
                    consúltenos por correo electrónico a
                    <a href="mailto:contrato@antirion.cl"
                        >contrato@antirion.cl</a
                    >
                </p>
            </div>
        </rz-content-wrapper>
    </section>
</template>

<script>
import AppPageTitle from '@/components/AppPageTitle.vue';
import RzContentWrapper from '@/components/layout/RzContentWrapper.vue';

export default {
    components: {
        AppPageTitle,
        RzContentWrapper,
    },
    data() {
        return {
            loading: true,
            status: null,
        };
    },
};
</script>
<style lang="scss" scoped></style>
